import { ElMessage } from 'element-plus'
import {Plus} from "@element-plus/icons-vue";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";
import {getDoctorInfo, updateDoctorInfo, updateUserPwd, getOutpatientServiceList} from '@/api'
import {uploadUrl} from "@/api/http";

export default {
    components: {Plus},
    data() {
        return {
            userInfo: null,
            sysName:"",
            activePersonTab: 'baseInfo',
            imageUrl:'',
            personBaseInfoFrom: {
                headImg: null,
                name: null,
            },
            queryDocId: null,
            doctorInfo: {
                doctorId: null,
                userId: null,
                headPic: null, // 头像
                qrCode: null, // 医生二维码
                name: null, // 姓名
                email: null, // 邮箱
                phoneNumber: null, // 手机号码
                age: null, // 年龄
                workTitle: null, // 职称
                goodAt: null, // 擅长
                introduction: null, // 简介
                odIds: null, // 关联门诊列表
                clinicDocPrice: null,
                clinicDocPriceRate: null,
                clinicDocPriceWay: 0,
                clinicDocPriceHide:0, // 门诊诊费 0 显示  1 隐藏
                medNewRule: "0", // 新标剂量转换设置
            },

            uploadFileURL: uploadUrl,
            uploadHeaders: {
                Authorization: 'Bearer ' + window.sessionStorage.getItem('xtoken')
            },

            oldPassword: undefined,
            newPassword: undefined,
            confirmPassword: undefined,

            outpatientList: [], // 门诊列表
            newRuleOpen: false, // 新标剂量转换设置
        }
    },
    created() {
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.queryDocId = this.doctorInfo.doctorId;
            if (this.doctorInfo.headPic === null || this.doctorInfo.headPic === "" || this.doctorInfo.headPic === undefined) {
                this.imageUrl = baseConfig.tencentCosUrl + "/tcmmsPic/profile.jpg";
            } else {
                this.imageUrl = baseConfig.tencentCosUrl + this.doctorInfo.headPic;
            }
            if (this.doctorInfo.clinicDocPrice === null || this.doctorInfo.clinicDocPrice === undefined || this.doctorInfo.clinicDocPrice === '') {
                this.doctorInfo.clinicDocPrice = "0";
            }
            if (this.doctorInfo.clinicDocPriceRate === null || this.doctorInfo.clinicDocPriceRate === undefined || this.doctorInfo.clinicDocPriceRate === '') {
                this.doctorInfo.clinicDocPriceRate = "0";
            }
            if (this.doctorInfo.medNewRule === "" || this.doctorInfo.medNewRule === null || this.doctorInfo.medNewRule === undefined) {
                this.doctorInfo.medNewRule = "0";
            }
            if (this.doctorInfo.medNewRule === "1") {
                this.newRuleOpen = true;
            } else {
                this.newRuleOpen = false
            }
        }
        this.getOutpatientList(); // 获取所有门诊列表
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 选择个人中心的tab
        choosePersonTab(idname) {
            this.activePersonTab = idname;
        },

        beforeAvatarUpload(rawFile) {
            if (rawFile.type !== 'image/jpeg') {
                ElMessage.error('Avatar picture must be JPG format!')
                return false;
            } else if (rawFile.size / 1024 / 1024 > 2) {
                ElMessage.error('Avatar picture size can not exceed 2MB!')
                return false;
            }
            return true;
        },

        handleAvatarSuccess(response, uploadFile) {
            this.imageUrl = URL.createObjectURL(uploadFile.raw);
            console.log(response)
            if (response.code === 200) {
                this.doctorBaseInfo.headPic = response.fileName;
            }
        },

        // 获取所有门诊列表
        getOutpatientList() {
            let data = {};
            getOutpatientServiceList(data).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.outpatientList = response.data.rows;
                }
            });
        },

        // 更新医生基本信息
        updateDoctorBaseInfo() {
            updateDoctorInfo(this.doctorBaseInfo).then(response => {
                console.log(response);
                if (response.code === 200) {
                    message('更新基本信息成功', "success");
                    this.getDoctorInfoByDoctorId(); // 刷新医生基本信息
                } else {
                    message('更新基本信息失败', "error");
                }
            });
        },


        // 获取医生信息
        getDoctorInfoByDoctorId() {
            getDoctorInfo(this.queryDocId).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.doctorInfo = response.data.data;
                    if (this.doctorInfo.medNewRule === "" || this.doctorInfo.medNewRule === null || this.doctorInfo.medNewRule === undefined) {
                        this.doctorInfo.medNewRule = "0";
                    }
                    if (this.doctorInfo.medNewRule === "1") {
                        this.newRuleOpen = true;
                    } else {
                        this.newRuleOpen = false
                    }
                    window.sessionStorage.removeItem("newRuleOpen");
                    window.sessionStorage.setItem("newRuleOpen", this.newRuleOpen);
                    window.sessionStorage.removeItem("doctorInfo");
                    window.sessionStorage.setItem("doctorInfo", JSON.stringify(response.data.data));
                }
            });
        },

        // 保存门诊诊费
        saveDocPriceInfoFn() {
            this.$confirm('确定要保存门诊诊费吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                updateDoctorInfo(this.doctorInfo).then(response => {
                    if (response.code === 200) {
                        message('门诊诊费保存成功', "success");
                        this.getDoctorInfoByDoctorId(); // 刷新医生基本信息
                    } else {
                        message('门诊诊费保存失败', "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消修改');
            })

        },

        // 开启或关闭颗粒的新标计算
        // 新标转换设置 0 关闭  1 开启
        newRuleOpenFunc() {
            console.log(this.newRuleOpen);
            this.newRuleOpen = !this.newRuleOpen;
            if (this.newRuleOpen) {
                this.doctorInfo.medNewRule = "1";
            } else {
                this.doctorInfo.medNewRule = "0";
            }
        },


        // 取消保存新标转换设置
        cancelSaveSwitchNewRule() {
            this.getDoctorInfoByDoctorId(); // 刷新医生基本信息
        },

        // 保存新标转换设置
        saveDocNewRuleFn() {
            console.log(this.newRuleOpen);
            let msg = "";
            if (this.newRuleOpen) {
                this.doctorInfo.medNewRule = "1";
                msg = "开启";
            } else {
                this.doctorInfo.medNewRule = "0";
                msg = "关闭";
            }
            this.$confirm('确定要'+msg+'新标剂量转换设置吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                updateDoctorInfo(this.doctorInfo).then(response => {
                    if (response.code === 200) {
                        message(msg + "成功", "success");
                        this.getDoctorInfoByDoctorId(); // 刷新医生基本信息
                    } else {
                        message(msg + "失败", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消修改');
            })

        },


        // 取消保存门诊诊费设置
        cancelSaveDocPriceInfo() {
            this.getDoctorInfoByDoctorId(); // 刷新医生基本信息
        },


        // 确定修改密码
        sureEditPassword() {
            var pwdPattern = /^[a-zA-Z0-9]{6,10}$/;
            if (this.oldPassword === undefined || this.oldPassword === null || this.oldPassword === "") {
                message("旧密码不能为空！");
            } else if (this.newPassword === undefined || this.newPassword === null || this.newPassword === "") {
                message("新密码不能为空！")
            } else if (!pwdPattern.test(this.newPassword)) {
                message("密码需是6-10位字母或数字组成！")
            } else if (this.confirmPassword === undefined || this.confirmPassword === null || this.confirmPassword === "") {
                message("确认密码不能为空！")
            } else if (this.confirmPassword !== this.newPassword) {
                message("两次输入密码不一致！")
            } else {
                this.$confirm('密码修改成功，需要立即重新登录?', '温馨提示', {
                    confirmButtonText: '立即修改',
                    cancelButtonText: '暂不修改',
                    type: 'success',
                    center: true
                }).then(() => {
                    const data = {
                        oldPassword: this.oldPassword,
                        newPassword: this.newPassword
                    }
                    updateUserPwd(data).then(response => {
                        if (response.data.code === 200) {
                            message('密码修改成功', "success");
                            window.sessionStorage.clear();
                            window.sessionStorage.clear();
                            this.$router.push({path: '/login'});
                        } else {
                            message('密码修改失败', "error");
                        }
                    })
                }).catch(() => {
                    message('您已取消本次修改', "warning");
                });

            }

        },
    }
}